module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ProgressView.js"));
	}, "MyProgressView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MyProgressView!./src/pages/Learn/My/Progress/ProgressView.js
// module id = 1756
// module chunks = 418